import {
    AfterViewChecked,
    AfterViewInit,
    Component,
    computed,
    ElementRef,
    HostListener,
    input,
    viewChild,
} from '@angular/core';


const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);


@Component({
    selector: 'cover-image',
    template: `
        <div class="svg-container" #svgContainer>
            <svg xmlns="http://www.w3.org/2000/svg" [attr.viewBox]="viewBox()" #svgObject style="position: relative">
                <foreignObject [attr.width]="width()" [attr.height]="height()">
                    <xhtml:body xmlns="http://www.w3.org/1999/xhtml" style="transform: scale(1) translate(0, 0); transform-origin: 0 0">
                        <ng-content></ng-content>
                    </xhtml:body>
                </foreignObject>
            </svg>
        </div>
    `,
})
export class CoverImageComponent implements AfterViewInit, AfterViewChecked {

    private initialOrientation = true;

    private initialLeftOffset: number;

    private initialTopOffset: number;

    width = input(900);

    height = input(1164);

    viewBox = computed(() => `0 0 ${this.width()} ${this.height()}`);

    svgObject = viewChild.required<ElementRef>('svgObject');

    svgContainer = viewChild.required<ElementRef>('svgContainer');

    ngAfterViewInit() {
        this.forceRedraw();

        if (isSafari) {
            const svgContainerElement = this.svgContainer().nativeElement;
            const svgElement = this.svgObject().nativeElement;

            const leftOffset = svgContainerElement.getBoundingClientRect().left - svgElement.getBoundingClientRect().left;
            const topOffset = svgContainerElement.getBoundingClientRect().top - svgElement.getBoundingClientRect().top;

            this.initialLeftOffset = svgElement.style.left = leftOffset;
            this.initialTopOffset = svgElement.style.top = topOffset;
        }
    }

    ngAfterViewChecked() {
        if (isSafari) {
            this.safariRedraw();
        }
    }

    private safariRedraw() {
        const svgContainerElement = this.svgContainer().nativeElement;
        const svgElement = this.svgObject().nativeElement;

        const zoomLevel = svgContainerElement.clientWidth / this.width();
        svgElement.style.transform = `scale(${zoomLevel})`;
        svgElement.style.transformOrigin = `0 0`;

        if (this.initialOrientation) {
            svgElement.style.left = this.initialLeftOffset;
            svgElement.style.top = this.initialTopOffset;
        } else {
            if (Math.abs(window.orientation) === 90) {
                svgElement.style.left = -75;
                svgElement.style.top = -95;
            } else {
                svgElement.style.left = -50;
                svgElement.style.top = -75;
            }
        }
    }

    @HostListener('window:resize')
    onResize() {
        this.forceRedraw();

        if (isSafari) {
            this.safariRedraw();
        }
    }

    @HostListener('window:orientationchange')
    onOrientationChange() {
        this.initialOrientation = !this.initialOrientation;
        this.onResize();
    }

    private forceRedraw() {
        this.svgContainer().nativeElement.style.opacity = '0';
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.svgContainer().nativeElement.style.opacity = '1';
            });
        });
    }
}
